<h2 [innerHTML]="roughcheck.title"></h2>
<div class="container-fluid col-md-6 float-end mb-3">
<div class="card border border-outline">
<img
  class="img-thumbnail"
  [src]="roughcheck.image"
  [alt]="roughcheck.image_alt"
  [title]="roughcheck.image_alt"
>
<div class="card-footer" [innerHTML]="roughcheck.image_alt"></div>
</div>
</div>
<div [innerHTML]="roughcheck.description"></div>
<div class="row">
<div class="col-sm-2"><p i18n="Sponsored by">LABEL_SPONSORED_BY</p></div>
<div class="col-sm-10"><a
  [href]="roughcheck.website"
  target="_blank">
  <span [innerHTML]="roughcheck.sponsor"></span>
  <span class="fas fa-external-link-alt ml-1"></span></a>
</div>
</div>
<div class="row">
<div class="col">
<button
  (click)="clickChange()"
  class="btn btn-secondary"
  i18n="Change">BUTTON_CHANGE</button>
<button
  (click)="clickNext()"
  class="btn btn-primary float-end"
  i18n="Next">BUTTON_NEXT</button>
</div>
</div>
